import React from 'react';
import styled from '@emotion/styled';
import { IButtonProps } from './Button';
import { Loader } from '../Loader/Loader';
import { Color } from '../../../features/shared/styles/Color';
import { ArrowButton } from './ArrowButton';

interface IStyledButton extends IButtonProps {
	isLoading?: boolean;
}

export const ButtonWithLoader = ({
	children,
	isLoading,
	...props
}: IStyledButton) => (
	<StyledButton
		data-testid="buttonWithLoader"
		disabled={isLoading}
		isLoading={!!isLoading}
		{...props}
	>
		{isLoading && (
			<StyledButtonLoader>
				<Loader color={Color.TextWhite} />
			</StyledButtonLoader>
		)}
		{!isLoading && children}
	</StyledButton>
);

const StyledButton = styled(ArrowButton)<{ isLoading: boolean }>`
	white-space: nowrap;
`;

const StyledButtonLoader = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
`;
